import { LIMIT_BYTE } from "@constants";

const fieldTypeEnum = {
    TEXT_FIELD: LIMIT_BYTE.comment,
    NUMBER: LIMIT_BYTE.comment,
    TEXT_AREA: LIMIT_BYTE.description,
};

export default fieldTypeEnum;
